/* tslint:disable: no-magic-numbers */
export const AgeGateBlacklist = {
    advertiser: {
        ids: [
            // 15142381, // NOTE: for dev only!
            118029421,
            129344461,
            4420631957,
            4445602465,
            4478460665,
            4513367905,
            4525362137,
            4528708924,
            4529087420,
            4538991029,
            4552172073,
            4559986059,
            4561803726,
            4567476945,
            4577987662,
            4582685415,
            4582887974,
            4584377759,
            4584711008,
            4585343252,
            4594447339,
            4609354044,
            4609356879,
            4609984445,
            4611428804,
            4611552924,
            4613163241,
            4613230769,
            4614148467,
            4615290658,
            4619578530,
            4621550146,
            4621580764,
            4621945085,
            4625629089,
            4633459918,
            4636168542,
            4636388061,
            4636912230,
            4636923820,
            4643528143,
            4646938443,
            4648366719,
            4651275336,
            4652408871,
            4657981817,
            4658771490,
            4660872853,
            4667466222,
            4677338118,
            4691792532,
            4695447086,
            4698166207,
            4699618287,
            4701834910,
            4704537056,
            4714482921,
            4715813734,
            4724060152,
            4728633963,
            4736573991,
            4740035682,
            4740986131,
            4741903881,
            4742541823,
            4752968130,
            4767150168,
            4771552983,
            4810107512
        ]
    }
}
/* tslint:enable: no-magic-numbers */
